<template>
  <div>
    <!-- 面包屑导航 -->
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <a-breadcrumb style="margin: 16px 0">
        <a-breadcrumb-item>主页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
        <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
      </a-breadcrumb>
      <div>
        <a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
        <a-button class="qinang-button-margin" icon="edit" @click="tableEdit" :disabled="!tableSelectedRows.length || tableSelectedRows.length !== 1">修改</a-button>
        <a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
        <a-button icon="sync" @click="apiPriceDiscountList">刷新</a-button>
      </div>
    </div>

    <!-- 查询区域 -->
    <a-collapse expandIconPosition="right" activeKey="1">
      <a-collapse-panel key="1" header="优惠政策查询">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="width: 30%; display: flex; align-items: center;">
            <div style="width: 100px;">服务商：</div>
            <a-select
              v-model="query.facilitatorId"
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              style="width: 100%"
              placeholder="请选择服务商"
              allowClear
            >
              <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
                {{ item.facilitatorName }}
              </a-select-option>
            </a-select>
          </div>
          <div style="display: flex; justify-content: flex-end;">
            <a-button type="primary" icon="search" @click="apiPriceDiscountList">查询</a-button>
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>

    <!-- 表格区域 -->
    <div class="qinang-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <a-breadcrumb separator=">" style="padding: 12.5px 16px;">
          <a-breadcrumb-item>优惠政策列表</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <a-table
        :row-selection="rowSelection"
        :columns="tableColumns"
        :data-source="tableData"
        row-key="priceDiscountId"
        :loading="tableLoading"
        :pagination="false"
      >
        <span slot="title" slot-scope="text, record">
          <a-button v-if="record && record.title" type="link" @click="edit(record)">{{ record.title }}</a-button>
        </span>
        <span slot="facilitatorName" slot-scope="text, record">
          {{ facilitatorList.find(item => item.facilitatorId === record.facilitatorId)?.facilitatorName || record.facilitatorId }}
        </span>
        <span slot="priceDiscountType" slot-scope="text, record">
          {{ priceDiscountTypeMap[record.priceDiscountType] || record.priceDiscountType }}
        </span>
       <span slot="tableAction" slot-scope="record">
					<a-button type="link" @click="PriceDiscountDetails(record)" >优惠政策管理</a-button>
          </span>
      </a-table>
      <a-pagination
        style="text-align: right; margin: 10px;"
        :current="query.page"
        :total="query.total"
        :default-page-size="query.size"
        show-size-changer
        show-quick-jumper
        size="small"
        :page-size-options="['10', '20', '50']"
        :show-total="total => `共 ${total} 条记录`"
        @change="pageChange"
        @showSizeChange="showSizeChange"
      />
    </div>

    <!-- 添加弹窗 -->
    <a-modal
      class="qa-modal-half"
      title="添加优惠政策"
      width="600px"
      :visible="addVisible"
      :confirm-loading="addConfirmLoading"
      @ok="addHandleOk"
      @cancel="handleCancel"
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form-model
        ref="addRuleForm"
        :model="addForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
        :rules="addRules"
      >
        <a-form-model-item label="规则名称" has-feedback prop="title">
          <a-input v-model="addForm.title" placeholder="请输入规则名称" />
        </a-form-model-item>
        <a-form-model-item label="服务商" has-feedback prop="facilitatorId">
          <a-select
            v-model="addForm.facilitatorId"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            placeholder="请选择服务商"
          >
            <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
              {{ item.facilitatorName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="折扣规则类型" has-feedback prop="priceDiscountType">
          <a-select v-model="addForm.priceDiscountType" placeholder="请选择折扣规则类型">
            <a-select-option v-for="(value, key) in priceDiscountTypeMap" :value="key" :key="key">
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="addForm.remark" :rows="3" placeholder="请输入备注" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 修改弹窗 -->
    <a-modal
      class="qa-modal-half"
      title="修改折扣规则"
      width="600px"
      :visible="editVisible"
      :confirm-loading="editConfirmLoading"
      @ok="editHandleOk"
      @cancel="handleCancel"
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form-model
        ref="editRuleForm"
        :model="editForm"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }"
        :rules="addRules"
      >
        <a-form-model-item label="规则名称" has-feedback prop="title">
          <a-input v-model="editForm.title" placeholder="请输入规则名称" />
        </a-form-model-item>
        <a-form-model-item label="服务商" has-feedback prop="facilitatorId">
          <a-select
            v-model="editForm.facilitatorId"
            show-search
            option-filter-prop="children"
            :filter-option="filterOption"
            placeholder="请选择服务商"
            disabled
          >
            <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId" :key="index">
              {{ item.facilitatorName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="折扣规则类型" has-feedback prop="priceDiscountType">
          <a-select v-model="editForm.priceDiscountType" placeholder="请选择折扣规则类型" disabled>
            <a-select-option v-for="(value, key) in priceDiscountTypeMap" :value="key" :key="key">
              {{ value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="editForm.remark" :rows="3" placeholder="请输入备注" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>


export default {
  data() {
    return {
      selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
      selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
      // 服务商列表
      facilitatorList: [],
      // 折扣规则类型映射
      priceDiscountTypeMap: {
        '1': '门票数量',
        '2': '总金额'
       
      },
      // 查询参数
      query: {
        page: 1,
        size: 10,
        total: 0,
        facilitatorId: undefined,
        title: ''
      },
      // 表格数据
      tableData: [],
      tableColumns: [
        { title: 'ID', dataIndex: 'priceDiscountId', key: 'priceDiscountId', align: 'center' },
        { title: '规则名称', dataIndex: 'title', key: 'title', align: 'center', scopedSlots: { customRender: 'title' } },
        { title: '服务商', key: 'facilitatorName', align: 'center', scopedSlots: { customRender: 'facilitatorName' } },
        { title:'操作', key:'tableAction', align:'center', scopedSlots:{customRender:'tableAction'}},
        { title: '折扣规则类型', dataIndex: 'priceDiscountType', key: 'priceDiscountType', align: 'center', scopedSlots: { customRender: 'priceDiscountType' } },
        { title: '备注', dataIndex: 'remark', key: 'remark', align: 'center' }
      ],
      tableLoading: false,
      tableSelectedRows: [],
      // 新增弹窗
      addVisible: false,
      addConfirmLoading: false,
      addForm: {
        title: '',
        facilitatorId: undefined,
        priceDiscountType: undefined,
        remark: ''
      },
      addRules: {
        title: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
        facilitatorId: [{ required: true, message: '请选择服务商', trigger: 'change' }],
        priceDiscountType: [{ required: true, message: '请选择折扣规则类型', trigger: 'change' }]
      },
      // 修改弹窗
      editVisible: false,
      editConfirmLoading: false,
      editForm: {
        priceDiscountId: '',
        title: '',
        facilitatorId: undefined,
        priceDiscountType: undefined,
        remark: ''
      }
    };
  },

  methods: {
    // 获取服务商列表
    async apiFacilitatorList() {
      const { data: res } = await this.$http.post(this.navigation.apiFacilitatorList, {
        staffId: window.sessionStorage.getItem('staffId')
      });
      if (res.code === 200) {
        this.facilitatorList = res.data;
        this.apiPriceDiscountList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 查询价格折扣规则列表
    async apiPriceDiscountList() {
      this.tableLoading = true;
      try {
        const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountQueryList, this.query);
        if (res.code === 200) {
          this.tableData = (res.data.list || []).filter(item => item && typeof item === 'object');
          
          if (res.data && res.data.pages){
            this.query.page = res.data.pages?.page || 1;
            this.query.size = res.data.pages?.size || 10;
            this.query.total = res.data.pages?.total || 0;
          } 
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      } catch (error) {
        this.$message.error('请求失败，请稍后重试');
        console.error('apiPriceDiscountList error:', error);
      } finally {
        this.tableLoading = false;
      }
    },
    // 分页变化
    pageChange(page, pageSize) {
      this.query.page = page;
      this.query.size = pageSize;
      this.apiPriceDiscountList();
    },
    showSizeChange(current, size) {
      this.query.page = current;
      this.query.size = size;
      this.apiPriceDiscountList();
    },
    // 过滤选项
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 取消弹窗
    handleCancel() {
      this.addVisible = false;
      this.editVisible = false;
    },
    // 新增
    tableAdd() {
      this.addVisible = true;
      this.addConfirmLoading = false;
      this.addForm = {
        title: '',
        facilitatorId: undefined,
        priceDiscountType: undefined,
        remark: ''
      };
      if (this.$refs.addRuleForm) {
        this.$refs.addRuleForm.resetFields();
      }
    },
    async apiPriceDiscountAdd() {
      this.addConfirmLoading = true;
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountAdd, this.addForm);
      if (res.code === 200) {
        this.$message.success(res.msg);
        if (this.$refs.addRuleForm) {
          this.$refs.addRuleForm.resetFields();
        }
        this.addConfirmLoading = false;
        this.addVisible = false;
        this.apiPriceDiscountList();
      } else {
        this.$message.error(res.msg);
        this.addConfirmLoading = false;
      }
    },
    addHandleOk() {
      this.$refs.addRuleForm.validate(valid => {
        if (valid) {
          this.apiPriceDiscountAdd();
        } else {
          return false;
        }
      });
    },
    // 修改
    async edit(item) {
      this.editVisible = true;
      this.editConfirmLoading = false;
      this.editForm = { ...item,  priceDiscountType: String(item.priceDiscountType)};
    },
    async apiPriceDiscountEdit() {
      this.editConfirmLoading = true;
      const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountEdit, this.editForm);
      if (res.code === 200) {
        this.$message.success(res.msg);
        this.editConfirmLoading = false;
        this.editVisible = false;
        this.apiPriceDiscountList();
      } else {
        this.$message.error(res.msg);
        this.editConfirmLoading = false;
      }
    },
    editHandleOk() {
      this.$refs.editRuleForm.validate(valid => {
        if (valid) {
          this.apiPriceDiscountEdit();
        } else {
          return false;
        }
      });
    },
    // 删除
    tableDel() {
      let that = this;
      if (this.tableSelectedRows.length > 0) {
        const ids = this.tableSelectedRows.map(row => row.priceDiscountId);
        this.$confirm({
          title: '确定要删除当前选中数据吗',
          content: '当前选中' + ids.length + '条数据。',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            that.apiPriceDiscountDel(ids);
          },
          onCancel() {}
        });
      } else {
        this.$message.warning('请选择要删除的数据');
      }
    },
    async apiPriceDiscountDel(ids) {
       const { data: res } = await this.$http.post(this.navigation.apiPriceDiscountDel, {ids: ids});
      if (res.code === 200) {
        this.$message.success('删除成功');
        this.tableSelectedRows = [];
        await this.apiPriceDiscountList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 编辑按钮点击事件
    tableEdit() {
      if (this.tableSelectedRows.length === 1) {
        const item = this.tableData.find(item => item.priceDiscountId === this.tableSelectedRows[0].priceDiscountId);
        this.edit(item);
      } else {
        this.$message.warning('请选择要修改的数据');
      }
    },

    PriceDiscountDetails(record) {
      if (record == undefined) {
        if (this.tableSelectedRows.length == 0) {
          this.$message.warning('请选择要修改的数据');
          return;
        }
        record = this.tableSelectedRows[0];
      }


      let priceDiscountMain = [];
      priceDiscountMain[0] = {
        'facilitatorId': record.facilitatorId,
        'facilitatorName': this.facilitatorList.find(item => item.facilitatorId == record.facilitatorId)?.facilitatorName || '' 
      };
      priceDiscountMain[1] = {
        'priceDiscountId': record.priceDiscountId,
        'title': record.title,
        'priceDiscountType': record.priceDiscountType
      };

      window.sessionStorage.setItem("priceDiscountMain", JSON.stringify(priceDiscountMain));
      this.$router.push('/PriceDiscountDetails');
    }
  },
  computed: {
    rowSelection() {
      let that = this;
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          that.tableSelectedRows = selectedRows;
        }
      };
    }
  },
  created() {
    this.apiFacilitatorList().then(() => {
      this.apiPriceDiscountList();
    });
  }
};
</script>

<style scoped></style>